var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"product-roadmap right-container",attrs:{"id":"roadmap","data-anchor":"roadmap"}},[_c('h2',{staticClass:"is-large"},[_vm._v("Product Roadmap")]),_c('Slider',{attrs:{"slides":_vm.slides,"is-large":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }